export interface Guide {
  title?: string;
  description?: string;
  videoUrl?: string;
  pdfUrl?: string;
  // Legacy fields (for backward compatibility)
  imageUrl?: string;
  imageMediumUrl?: string;
  imageLargeUrl?: string;
  thumbnailUrl?: string;
  // New structure (deprecated)
  images?: GuideImages;
  mockups?: GuideMockups;
  // Newest structure
  key?: string;
  extension?: string;
  order?: number;
  categories?: string[];
}

export interface GuideImages {
  thumbnail?: string;
  small?: string;
  medium?: string;
  large?: string;
}

export interface GuideMockups {
  small?: string;
  medium?: string;
  large?: string;
}
